if (!customElements.get("lazy-video")) {
	customElements.define(
		"lazy-video",
		class LazyVideo extends HTMLElement {
			constructor() {
				super();

				this.observer = new IntersectionObserver(
					this.handleIntersection.bind(this),
					{
						rootMargin: "0px",
						threshold: 0.1,
					}
				);
			}

			connectedCallback() {
				this.observer.observe(this);
				this.style.backgroundImage = `url('${this.dataset.posterSrc}')`;
			}

			disconnectedCallback() {
				this.observer.unobserve(this);
			}

			handleIntersection(entries, observer) {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this.loadVideo();
						observer.unobserve(this);
					}
				});
			}

			loadVideo() {
				const isMobile = window.matchMedia("(max-width: 768px)").matches;
				const videoSrc = isMobile
					? this.dataset.videoMobileSrc
					: this.dataset.videoDesktopSrc;
				const videoClass = isMobile
					? "hero__video hero__video--mobile"
					: "hero__video hero__video--desktop";

				const video = document.createElement("video");

				video.className = videoClass;
				video.src = videoSrc;
				video.autoplay = true;
				video.loop = true;
				video.muted = true;
				video.playsInline = true;
				video.controls = false;

				this.appendChild(video);

				video.addEventListener(
					"canplay",
					() => {
						video.classList.add("video__playable");
					},
					{ once: true }
				);
			}
		}
	);
}
